<template>
  <v-row>
    <v-col class="py-0">
      <div class="tcdc-partner-card-border pa-5" @click="onClick">
        <v-img contain :src="img" class="tcdc-partner-card-image" aspect-ratio="1" max-height="320px" />
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ['img'],
  methods: {
    onClick() {
      this.$emit('onPress');
    }
  }
};
</script>

<style lang="scss" scoped>
.tcdc-partner-card-border {
  border: 1px solid #b0b0b0;
  cursor: pointer;
}
.tcdc-partner-card-image {
  width: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>
